module.exports = __webpack_public_path__ + "hue.0614c271.png";